/*jslint node: true, browser: true*/
"use strict";

var busyIndicator = require("pli/forms-busyindicator");
var ko = require("pli/knockout");
var pli = require("pli/forms");
var viewModelInit = require("pli/forms-viewmodel");



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PicklistItemViewModelExtensions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function PicklistItemViewModelExtensions(apiPrefix, form) {

    // Initialize default properties (serialized)
    this.guid = ko.observable();

    // Initialize default properties (non-serialized)
    this.extras = function picklistItemExtras() { return; };
    this.extras.apiPrefix = apiPrefix;
    this.extras.apiSave = "".concat(this.extras.apiPrefix).concat("Save");
    this.extras.apiLoad = "".concat(this.extras.apiPrefix).concat("Load");
    this.extras.dirty = ko.dirtyFlag(this);
    this.extras.form = form;
    this.extras.message = ko.observable();
    this.extras.state = ko.observable("ready");

    // Initialize default actions
    this.close = PicklistItemViewModelExtensions.prototype.close.bind(this);
    this.open = PicklistItemViewModelExtensions.prototype.open.bind(this);
    this.save = PicklistItemViewModelExtensions.prototype.save.bind(this);
    this.handleEnter = PicklistItemViewModelExtensions.prototype.handleEnter.bind(this);

    // private actions
    this._applyValidationErrors = PicklistItemViewModelExtensions.prototype._applyValidationErrors.bind(this);
    this._processSaveResponse = PicklistItemViewModelExtensions.prototype._processSaveResponse.bind(this);
    this._processLoadResponse = PicklistItemViewModelExtensions.prototype._processLoadResponse.bind(this);
    this._validateDeep = PicklistItemViewModelExtensions.prototype._validateDeep.bind(this);

    // Initialize default keymap
    pli.keys.registerKeymap(form.id, ko.utils.extend(
        ko.utils.extend({}, pli.config.defaultKeymap),
        {
            "Accept": this.handleEnter,
            "Save": this.save,
            "Close": this.close
        }
    ));
    form.page.keymap = form.id;
}


//-------------------------------------------
PicklistItemViewModelExtensions.prototype.close = function closePicklistItem(force) {
    /// <summary>
    /// Closes a picklist form if the form is
    /// not busy (unless forced).
    /// </summary>
    if (force || this.extras.state() !== "busy") { pli.forms.close(this.extras.form.id); }
    return false; // prevent default behaviour
};


//-------------------------------------------
PicklistItemViewModelExtensions.prototype.open = function openPicklistItem(settings) {
    /// <summary>
    /// Opens a picklist form with the data
    /// specified.
    /// </summary>

    // load/reset view model properties.
    this.extras.dirty.reset();
    this.extras.message("Details");
    this.extras.state("ready");

    // Load details from cache
    // Add logic to extract the array of array from multi-select picklist
    // There are currently 3 forms of data structure that come in opening a picklist item
    // 1) settings.data = from opening a custom picklist on the main landing page (ie. Area picklist)
    // 2) settings[0] = from opening a custom picklist in a document by selecting a picklist item and clicking "Open Selected"
    // 3) settings = from opening a generic picklist on the main landing page (ie. Acquisition Method)
    //
    // NOTE: settings.data no longer is passed in as an array but it is now a record.  No need to convert array to record
    // in majority of the 'fromCacheItem' call.
    var data = (typeof this.fromCacheItem === "function")
        ? this.fromCacheItem((settings && (settings[0] || settings.data)) || settings)
        : ((settings && settings.data) || settings);

    if (typeof this.load === "function") {
        this.extras.dirty.suspend();
        this.load(data);
        this.extras.dirty.resume(true);
    }

    // bind the form if it is not already
    if (!this.isBound) {
        ko.applyBindings(this, this.extras.form.$form[0]);
        this.isBound = true;
    }

    // show the inline form
    pli.forms.open(this.extras.form.id);

    if (this.extras.state() === "loading" && this.guid()) {
        busyIndicator.open({
            title: "Loading, please wait..."
        });

        pli.call({
            name: this.extras.apiLoad,
            jsonData: JSON.stringify({ id: this.guid() })
        }).always(this._processLoadResponse);
    }

    return false;// prevent default behaviour
};


PicklistItemViewModelExtensions.prototype.handleEnter = function saveIfNotInTextArea(event) {
    /// <summary>
    /// Handle submission of picklist editor as a result of the enter key.
    /// Calls save if we are not in a textarea or multiselect picklist
    /// (to allow enter in these boxes).
    /// </summary>
    if (document.activeElement.type !== "textarea" && document.activeElement.className !== "ms-input") {
        this.save();
    }
    event.stopPropagation();
};


//-------------------------------------------
PicklistItemViewModelExtensions.prototype.save = function savePicklistItem() {
    /// <summary>
    /// Handle submission of default picklist editor dialog
    /// (ENTER key or 'Save' button click).
    /// </summary>
    var state = this.extras.state();
    if ((state ===  "ready" || state === "fail") && this.extras.dirty()) {
        if (this._validateDeep()) {
            if (this.useSaveDialog) {
                busyIndicator.open({
                    title: "Saving, please wait..."
                });
            } else {
                this.extras.state("busy");
                this.extras.message("Saving, please wait...");
            }
            pli.call({
                name: this.extras.apiSave,
                jsonData: this.extras.dirty.currentJSON()
            }).always(this._processSaveResponse);
        } else {
            this.extras.state("fail");
            this.extras.message("Saving failed.");
            this.extras.form.$form.resetPopupFocus();
        }
    }

    return false;
};


//-------------------------------------------
PicklistItemViewModelExtensions.prototype._applyValidationErrors = viewModelInit.applyValidationErrors;


//-------------------------------------------
PicklistItemViewModelExtensions.prototype._processLoadResponse = function processPicklistLoadResponse(response) {
    /// <summary>
    /// Process server-side response to the load PLI call (both success
    /// and failure responses will arrive here).
    /// </summary>
    if (response.isError) {
        if (window.console) { window.console.warn("Picklist item loading failed:", this, response); }
        var r = response.result;
        var message = (r && r.message) || "Unable to load picklist item";
        this.extras.state("fail");
        this.extras.message(message);
        this._applyValidationErrors(r && r.validationErrors);
        this.extras.form.$form.resetPopupFocus();
        busyIndicator.complete({
            failed: true,
            message: message,
            title: "Unable to load picklist item",
            onClosed: this.close
        });
    } else {
        if (window.console) { window.console.log("Picklist item loading succeeded", response); }

        this.extras.dirty.suspend();
        this.load(response.result);
        this.extras.dirty.resume(true);

        busyIndicator.close({ force: true });
        this.extras.state("ready");
    }
};


//-------------------------------------------
PicklistItemViewModelExtensions.prototype._processSaveResponse = function processPicklistSaveResponse(response) {
    /// <summary>
    /// Process server-side response to the
    /// save PLI call (both success
    /// and failure responses will arrive here).
    /// </summary>
    if (response.isError) {
        if (window.console) { window.console.warn("Picklist item saving failed:", this, response); }
        var r = response.result;
        var message = (r && r.message) || "Unable to save picklist item";
        this.extras.state("fail");
        this.extras.message(message);
        this._applyValidationErrors(r && r.validationErrors);
        this.extras.form.$form.resetPopupFocus();
        busyIndicator.close({ force: true });
    } else {
        if (window.console) { window.console.log("Picklist item saving succeeded", response); }
        busyIndicator.close({ force: true });
        this.close(true);
    }
};


//-------------------------------------------
PicklistItemViewModelExtensions.prototype._validateDeep = viewModelInit.validateDeep;


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = {
    mixins: { initPicklistItem: PicklistItemViewModelExtensions }
};



//////////////////
// WEBPACK FOOTER
// ./app/picklist-common/picklistItemViewModelExtensions.js
// module id = 498
// module chunks = 49